import { SessionReportAvailability } from './types';

/**
 * 정산 화면의 「세션 현황」 탭을 보여 줄지.
 *
 * 10/19 사용자 결정: 세션 현황은 헬스보이짐 전용이 아니라 **정산 권한이 있는 모든 센터**의 화면이다.
 * 그래서 센터의 정산 방식(상세 정산 여부)·정산 분류 개수는 보지 않는다(보고서 계산과도 무관 — CROSS_CENTER_AUDIT_1019 §6-2).
 * 남는 조건은 서버 기능 사전 조회(probeSessionReport) 하나다 — 구서버(404)·권한 없음(403)이면 숨긴다.
 * 사전 조회가 실패하면 숨긴다(fail-closed). 묻는 중이면 'unknown' — 주소의 ?tab=sessionReport 를 바로 지우지 않는다.
 */
export type SessionReportMenuState = 'unknown' | 'available' | 'unavailable';

export const resolveSessionReportMenuState = ({
    probe,
}: {
    probe: { data?: SessionReportAvailability; isError: boolean };
}): SessionReportMenuState => {
    if (probe.isError) return 'unavailable';
    if (probe.data === 'unavailable') return 'unavailable';
    if (probe.data === 'available') return 'available';
    return 'unknown';
};
